export const ResultFrameworkTemplate = {
  // Deprecated? - not found in controller
  list: function () {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#result-framework-template-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery("#result-framework-templates"));
      },
      columnDefs: [
        {
          targets: [1, 2],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        ActionJS.ResultFrameworkTemplate.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var rfTable = jQuery("#result-framework-templates");
    rfTable.DataTable(options);
  },

  _apply: function() {
    jQuery('.select2').select2();

    jQuery('.select-none').on('click', function(){
      $(this).closest('.form-group').find('.select2').val(null).trigger('change');
    })

    jQuery('.select-all').on('click', function(){
      var allValues = $(this).closest('.form-group').find('.select2 option').map(function(i,v){ return v.value}).toArray()
      $(this).closest('.form-group').find('.select2').val(allValues).trigger('change');
    })

    jQuery('.select-group').on('click', function(){
      var values = $(this).closest('.form-group').find('.select2 optgroup[label="' + $(this).data('opt-group') + '"] option').map(function(i,v){ return v.value}).toArray()
      $(this).closest('.form-group').find('.select2').val(values).trigger('change');
    })

    $(".smartme-toggle").smartmeToggle();
  },

  priv: {
    bindEvent: function () {
      jQuery(".template-clone-link, .template-delete-link, .template-set-as-default-link")
        .off("click")
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data("confirm")) {
            c = confirm(jQuery(this).data("confirm"));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr("href"),
                method: "POST",
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
              })
              .done(function (d) {
                Turbo.visit(window.location.href);
              });
          }
          e.preventDefault();
        });
    },
  },
};
